
      import React from 'react';
      import ReactDOM from 'react-dom';
      import App from '/tmp/jenkins/workspace/ivacy_mfe-privacy-consent_main_2/packages/mfe-privacy-consent/src/index.tsx';
      import { Shell } from '@nike/web-shell-client-react';

      export default function RemoteComponentEntry(props) {
        return (
          <Shell {...props}>
            <App {...props} />
          </Shell>
        );
      };
    